import { z } from 'zod';
import { ACTIVATION_CODE_STORAGE_PATTERN, ACTIVATION_CODE_STORAGE_ERROR_MESSAGE, ACTIVATION_CODE_PATTERN, ACTIVATION_CODE_ERROR_MESSAGE, } from '../constants/validation';
/**
 * Allowed Email Schema
 * Validates email allowlist entries for gatekeeping activation
 */
export const AllowedEmailSchema = z.object({
    email: z.string().email('Invalid email address'),
    activationCode: z
        .string()
        .regex(ACTIVATION_CODE_STORAGE_PATTERN, ACTIVATION_CODE_STORAGE_ERROR_MESSAGE),
    codeUsed: z.boolean(),
    createdBy: z.string().uuid('Created by must be a valid UUID'),
    createdAt: z.string().datetime('Invalid datetime'),
    usedAt: z.string().datetime().optional(),
    usedBy: z.string().uuid().optional(),
});
/**
 * Add Allowed Email Request Schema
 * Validates admin request to add email to allowlist
 */
export const AddAllowedEmailRequestSchema = z.object({
    email: z.string().email('Invalid email address'),
    // Activation code will be auto-generated if not provided
    // Can be provided with or without dashes (XXXX-XXXX-XXXX-XXXX or XXXXXXXXXXXXXXXX)
    activationCode: z
        .string()
        .regex(ACTIVATION_CODE_PATTERN, ACTIVATION_CODE_ERROR_MESSAGE)
        .optional(),
});
/**
 * Remove Allowed Email Request Schema
 * Validates admin request to remove email from allowlist
 */
export const RemoveAllowedEmailRequestSchema = z.object({
    email: z.string().email('Invalid email address'),
});
//# sourceMappingURL=allowlist.js.map